module.exports = __webpack_public_path__ + "static/media/watch.f4136751.svg";